import React from 'react';
import cn from 'classnames';
import Flex from '@wix/da-ds/pkg/Flex';
import InputLabel from '@wix/da-ds/pkg/formControls/lego/InputLabel';
import InputLabelText from '@wix/da-ds/pkg/formControls/lego/InputLabelText';
import InputLabelSubText from '@wix/da-ds/pkg/formControls/lego/InputLabelSubText';

import s from './ButtonFieldLayout.scss';

interface Props {
  className?: string;
  label: React.ReactNode;
  labelClassName?: string;
  labelProps?: React.LabelHTMLAttributes<HTMLLabelElement>;
  subLabel?: React.ReactNode;
  subLabelClassName?: string;
  bottomSlot?: React.ReactNode;
}

const ButtonFieldLayout = React.forwardRef<
  HTMLDivElement,
  React.PropsWithChildren<Props>
>(({
  className,
  label,
  labelClassName,
  labelProps,
  subLabel,
  subLabelClassName,
  bottomSlot,
  children,
}, ref) => {
  return (
    <div className={cn(s['root'], className)} ref={ref}>
      <Flex direction="row" alignItems="center" justifyContent="space-between">
        <InputLabel className={s['label']} {...labelProps}>
          <InputLabelText
            className={cn(
              s['label-text'],
              labelClassName
            )}
          >
            {label}
          </InputLabelText>
          {subLabel && (
            <InputLabelSubText className={cn(
              s['sublabel-text'],
              subLabelClassName
            )}>
              {subLabel}
            </InputLabelSubText>
          )}
        </InputLabel>
        {children}
      </Flex>
      {bottomSlot}
    </div>
  );
});
ButtonFieldLayout.displayName = 'ButtonFieldLayout';

export default ButtonFieldLayout;
